import React, { useState } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { TextField } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import FlagstoneTheme from '../../Config/flagstoneTheme';
import { useTranslation } from 'react-i18next';

export default function PasswordDialog(props) {

    const classes = useStyles();
    const { t } = useTranslation();
    const [password, setPassword] = useState(null);

    const passwordChanged = (e) => {
        setPassword(e.target.value)
    }

    const save = () => {
        props.action(password)
        setPassword(null)
    }

    return (
        <Dialog className={classes.dialogContainer}
            open={props.dialogOpen}
            onClose={props.closeDialog}
            aria-labelledby="draggable-dialog-title"
        >
            <DialogTitle className={classes.dialogTitle} style={{ cursor: 'move' }} id="draggable-dialog-title">
                {props.dialogTitle}
            </DialogTitle>
            <div className={classes.dialogContext}>
                <div className={classes.textfield}>
                    <TextField id="outlined-search" label="" type="search" variant="outlined" value={password} className={classes.uiTextField} size="small" onChange={(e) => passwordChanged(e)} />
                </div>
            </div>

            <div className={classes.buttons}>
                <button className={classes.performTestButton} onClick={() => save()}>
                    {t("SAVE")}
                </button>
            </div>
        </Dialog>
    );
}


const useStyles = makeStyles(() => ({

    dialogContainer: {
        width: "380px !important",
        height: "320px !important",
        margin: "auto",
        "& > div > div": {
            backgroundImage: 'linear-gradient(#EFEFEF,#FFFFFF)',
            maxHeight: "none"
        },
    },
    buttons: {
        textAlign: "center",
    },
    performTestButton: {
        color: "white",
        fontSize: "14px",
        fontFamily: "Roboto",
        fontWeight: 'medium',
        backgroundColor: FlagstoneTheme.palette.primary.main,
        '&:hover': {
            backgroundColor: FlagstoneTheme.palette.primary.main,
        },
        width: "120px",
        outline:"none",
        border:"none",
        height:"40px",
        cursor:"pointer",
        marginBottom:"30px",
        marginTop:"20px"
    },
    dialogTitle: {
        color: "#000000",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        '& h2': {
            fontSize: "20px !important",
        },
        paddingTop: "30px",
        paddingBottom: "20px"
    },
    dialogContext: {
        color: "#000000",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        paddingLeft: "20px",
        paddingRight: "20px",
        height: "50px"
    },

    uiTextField: {
        width: "95%",
        backgroundColor: "white"
    },
    label: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#020100",
        textAlign: "left"
    },

}));
